import storeModule from '../store-module'
import { defineStore } from 'pinia'

export default defineStore('accessories-categorization', storeModule.createStoreModule('accessories-categorization'))
